import React, { memo, useCallback } from 'react';

import { useTranslation } from '@lyearn/i18n';
import useNavigation from '@/hooks/useNavigation';
import DeleteClientModal from '@/modules/clients/components/DeleteClientModal';
import { clientRoutes } from '@/modules/clients/routes';

import { DialogProps } from '../types';

function DeleteClient({ client, onClose }: DialogProps) {
  const { t } = useTranslation();
  const navigation = useNavigation();

  if (!client) {
    throw new Error(t('No client provided for deletion.'));
  }

  if (client && !('id' in client)) {
    throw new Error('No client Id found for deletion.', { cause: { client } });
  }

  const redirectToAllClients = useCallback(
    () => navigation.push(clientRoutes.Clients()),
    [navigation],
  );

  return <DeleteClientModal client={client} onClose={onClose} onSuccess={redirectToAllClients} />;
}

export default memo(DeleteClient);
